<template>
  <div class="article__search flex">
    <form class="asearch__form" method="post" @submit="handleArticleSearch">
      <label for="articleNumber">{{ $t("searchArticle") }}</label>

      <div class="fullwidth">
        <input
          type="text"
          name="sword"
          value
          :placeholder="$t('searchArticlePlaceholder')"
          v-model="articleNumber"
          class="form-control input-ready"
          @blur="setArticleNumber"
        />
        <!--    <input type="submit" name="search" value="Suchen" /> -->
        <button
          type="submit"
          class="btn submit icon-search directSearchButton"
        ></button>
      </div>
      <input
        type="hidden"
        name="humansIgnoreMe"
        value
        v-model="humansIgnoreMe"
      />
      <div class="error" v-if="articleNumberError">
        <strong>{{ $t("searchArticleError") }}</strong>
      </div>
      <div class="error" v-if="noValidProductError">
        <strong>{{ $t("noValidProductError") }}</strong>
      </div>
      <div class="hint" v-if="inputLengthError">
        <strong>{{ $t("searchArticleHint", { chars: minCharsInput }) }}</strong>
      </div>
    </form>
    <div class="product__suggestion-wrapper">
      <div class="product__suggestion" v-if="suggestedProducts.length">
        <!-- <h3>{{ $t("foundProductsText") }}</h3> -->
        <ul class="product__suggestion-list">
          <li
            v-for="(suggestedProduct, index) in suggestedProducts"
            :key="index"
          >
            <LampPreview
              :lamp="suggestedProduct"
              @set-suggested-article="selectSuggestedProduct"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import FdConfig from "@/../fd.config";
import LampPreview from "@/components/LampPreview";

export default {
  props: {
    minCharsInput: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      // articleNumber: 1006.733,
      articleNumber: null,
      humansIgnoreMe: null,
      articleNumberError: false,
      inputLengthError: false,
      noValidProductError: false,
      suggestedProducts: []
    };
  },
  methods: {
    handleArticleSearch(evt) {
      evt.preventDefault();
      if (!this.articleNumber) {
        this.articleNumberError = true;
      } else {
        this.articleNumberError = false;
        this.$emit("search-article", this.articleNumber);
      }
      console.log("Article search form submitted", this.articleNumber);
    },
    setArticleNumber() {
      if (this.articleNumber) {
        this.articleNumberError = false;

        // console.log(this.articleNumber, this.suggestedProducts);
        let isArticleNumberInSuggestedProducts = false;
        Object.keys(this.$store.getters.getProducts).forEach((idx, elem) => {
          // console.log(idx, elem, this.suggestedProducts[idx].productId);
          if (
            this.$store.getters.getProducts[idx].productId == this.articleNumber
          ) {
            isArticleNumberInSuggestedProducts = true;
          }
        });

        this.noValidProductError = !isArticleNumberInSuggestedProducts;

        this.$emit("search-article", this.articleNumber);
      } else {
        this.articleNumberError = true;
      }
    },
    getProductSuggestion(currentInput) {
      let maxResultElements = FdConfig.maxResultListCount || 25;
      let resultHits = 0;
      this.articleNumberError = false;

      this.inputLengthError = currentInput.length < this.minCharsInput;

      if (!this.inputLengthError) {
        let possibleProductMatches = [];
        let allProducts = this.$store.getters.getProducts;
        // console.log("allProducts: ", allProducts);
        // if (allProducts.length) {//if it would be an array, which it was before
        let objectKeys = Object.keys(allProducts);
        if (objectKeys.length) {
          //only show the first 25 hits to reduce render time for the LampPreview components.
          for (
            var i = 0, l = objectKeys.length;
            i < l && resultHits < maxResultElements;
            i++
          ) {
            let productKey = objectKeys[i];
            let possibleProductMatch = allProducts[productKey];
            if (
              -1 !== productKey.indexOf(currentInput) ||
              -1 !==
                possibleProductMatch.name
                  .toLowerCase()
                  .indexOf(currentInput.toLowerCase())
            ) {
              //either the productId or the productName looks like the given input, so we suggest this product
              possibleProductMatches.push(possibleProductMatch);
              resultHits++;
            }
          }
        } else {
          //no products loaded
          console.warn(
            "couldnt find any product with the id / name: ",
            currentInput
          );
        }
        this.suggestedProducts = possibleProductMatches;
        return possibleProductMatches;
      } else {
        this.clearSuggestedProducts();
      }
    },
    selectSuggestedProduct(productId) {
      this.articleNumber = productId;
      this.noValidProductError = false;
      this.$emit("search-article", this.articleNumber);
      this.$nextTick(() => {
        //clear results after user selected one of the suggested products
        this.clearSuggestedProducts();
      });
    },
    clearSuggestedProducts() {
      this.suggestedProducts = [];
    }
  },
  watch: {
    //eslint-disable-next-line
    articleNumber(newValue, oldValue) {
      if (newValue) {
        //maybe only suggest this after 3 letters were given?
        /* eslint-disable-next-line */
        let suggestedProducts = this.getProductSuggestion(newValue);
        // console.log("Possible suggested products: ", suggestedProducts);
      } else {
        this.clearSuggestedProducts();
      }
    }
  },
  components: {
    LampPreview
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/include-media.scss";
@import "@/assets/scss/_variables.scss";

.article__search {
  margin-bottom: 1em;
  flex-direction: column;
}

label,
input {
  display: block;
  // margin: 0.5rem auto;
  text-align: center;
  padding: 0.5rem;
}

form {
  width: 50%;
  margin: 0 auto;
  @include media("<desktop-ml") {
    width: 60%;
  }
  @include media("<desktop-s") {
    width: 75%;
  }
  @include media("<phone-l") {
    width: 100%;
  }
}

.product {
  &__suggestion {
    &-wrapper {
      position: relative;
    }
    position: absolute;
    transform: translateX(50%);
    width: 50%;
    margin: 0 auto;
    height: 150px;
    height: 55vh;
    padding: 1%;
    border: 1px solid silver;
    overflow-x: hidden;
    overflow-y: scroll;
    background-color: white;
    z-index: 13;
    @include media("<desktop-ml") {
      width: 60%;
      transform: translateX(30%);
    }
    @include media("<desktop-s") {
      width: 75%;
      transform: translateX(15%);
    }
    @include media("<phone-l") {
      width: 100%;
      transform: translateX(0%);
    }
    &-list {
      display: flex;
      flex-wrap: wrap;
      padding: 0;
      list-style: none;
      li {
        width: 100%;
      }
    }
  }
}

.fullwidth {
  display: flex;
  input {
    width: calc(100% - 40px);
  }
  button {
    width: 40px;
  }
}

.hint {
  color: #918700;
}
</style>
